// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"UploadLogo--next-sr-only--2iSpzCE","uploadContainer":"UploadLogo--uploadContainer--K7pQfaT"};